import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@mantine/core';
import { IconClock, IconPlayerPlay, IconCheck, IconX } from '@tabler/icons-react';

/**
 * ReviewStatusBadge - Reusable component for displaying review status
 * Shows specific, unambiguous status for each review state
 *
 * @param {Object} props
 * @param {string|null} props.status - Review status (null, 'submitted', 'in_progress', 'approved', 'rejected')
 * @param {string} props.size - Badge size ('sm', 'md', 'lg')
 * @param {string} props.variant - Badge variant ('filled', 'light', 'outline')
 */
function ReviewStatusBadge({ status, size = 'md', variant = 'light' }) {
  // Map status to badge configuration
  const statusConfig = {
    null: {
      label: 'Not Submitted',
      color: 'gray',
      icon: null
    },
    submitted: {
      label: 'Pending Review',
      color: 'yellow',
      icon: <IconClock size={14} />
    },
    in_progress: {
      label: 'In Review',
      color: 'blue',
      icon: <IconPlayerPlay size={14} />
    },
    approved: {
      label: 'Approved',
      color: 'green',
      icon: <IconCheck size={14} />
    },
    rejected: {
      label: 'Rejected',
      color: 'red',
      icon: <IconX size={14} />
    }
  };

  const config = statusConfig[status] || statusConfig.null;

  return (
    <Badge
      size={size}
      variant={variant}
      color={config.color}
      leftSection={config.icon}
    >
      {config.label}
    </Badge>
  );
}

ReviewStatusBadge.propTypes = {
  status: PropTypes.oneOf([null, 'submitted', 'in_progress', 'approved', 'rejected']),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  variant: PropTypes.oneOf(['filled', 'light', 'outline', 'dot'])
};

export default ReviewStatusBadge;
